/**
 * Project-wide configuration.  Manage runtime values centrally, and
 * import them from this file.
 */
const isProduction = process.env.NODE_ENV === 'production';
const isDevelopment = !isProduction;

export const config = {
  mode: process.env.NODE_ENV,
  ev: {
    url: process.env.NEXT_PUBLIC_DIGITAL_EXPERIENCE_API_URL,
    key: process.env.NEXT_PUBLIC_DIGITAL_EXPERIENCE_API_KEY,
  },
  shopServiceUrl: process.env.NEXT_PUBLIC_SHOP_SERVICE_URL || '',
  google: {
    key: process.env.GOOGLE_SEARCH_KEY || process.env.NEXT_PUBLIC_GOOGLE_SEARCH_KEY || '',
    id: process.env.GOOGLE_SEARCH_ID || process.env.NEXT_PUBLIC_GOOGLE_SEARCH_ID,
    mapKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY,
  },
  localLogic: {
    keyUS: process.env.NEXT_PUBLIC_LOCAL_LOGIC_KEY_US,
    keyCA: process.env.NEXT_PUBLIC_LOCAL_LOGIC_KEY_CA,
  },
  oneTrust: {
    cookieId: process.env.NEXT_PUBLIC_ONE_TRUST_COOKIE_ID,
  },
  recaptcha: {
    key: process.env.NEXT_PUBLIC_RECAPTCHA_KEY,
  },
  jazzHr: {
    baseUrlWithApiKey: process.env.NEXT_PUBLIC_JAZZ_HR_BASE_URL_WITH_API_KEY,
  },
  statsApiBaseUrl: process.env.NEXT_PUBLIC_SHOP_SERVICE_URL || '',
  strapiAPiBaseUrl: process.env.NEXT_PUBLIC_STRAPI_BASE_URL || '',
  prod: isProduction,
  dev: isDevelopment,
};
